
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mobiworkx/logout",
      function () {
        return require("private-next-pages/mobiworkx/logout.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mobiworkx/logout"])
      });
    }
  